import { PRODUCT_STATUS } from './productConstants';

/**
 *  페이지 이름
 */
export const COUPON_PAGE_NAME = {
  COUPON_CREATE: '쿠폰 생성',
  COUPON_DETAIL: '쿠폰 상세정보',
  COUPON_EDIT: '쿠폰 편집',
  COUPON_COPY: '쿠폰 복사',
  COUPON_GENERATE: '쿠폰 발급',
  COUPON_LIST: '쿠폰 리스트',
  COUPON_ISSUE_HISTORY_LIST: '쿠폰 발급 내역 리스트',
  COUPON_ISSUE_HISTORY_DETAIL: '쿠폰 발급 내역 상세',
};

/**
 *  쿠폰 적용 가능 범위 타입
 */
export const COUPON_AVAILABLE_TYPE = {
  /**
   *  전체 상품 쿠폰
   */
  TOTAL_PRODUCT_COUPON: 0,
  /**
   *  특정 상품 쿠폰
   */
  TARGET_PRODUCT_COUPON: 1,
  /**
   *  특정 브랜드 쿠폰
   */
  TARGET_BRAND_COUPON: 2,
};

/**
 *  쿠폰 적용 가능 범위 타입 TEXT
 */
export const COUPON_AVAILABLE_TYPE_TEXT = {
  [COUPON_AVAILABLE_TYPE.TOTAL_PRODUCT_COUPON]: '전체 상품 쿠폰',
  [COUPON_AVAILABLE_TYPE.TARGET_PRODUCT_COUPON]: '특정 상품 쿠폰',
  [COUPON_AVAILABLE_TYPE.TARGET_BRAND_COUPON]: '특정 브랜드 쿠폰',
};

/**
 *  쿠폰 적용 가능 범위 타입 SELECT LIST
 */
export const COUPON_AVAILABLE_TYPE_SELECT_LIST = [
  {
    id: COUPON_AVAILABLE_TYPE.TOTAL_PRODUCT_COUPON,
    name: COUPON_AVAILABLE_TYPE_TEXT[COUPON_AVAILABLE_TYPE.TOTAL_PRODUCT_COUPON],
  },
  {
    id: COUPON_AVAILABLE_TYPE.TARGET_PRODUCT_COUPON,
    name: COUPON_AVAILABLE_TYPE_TEXT[COUPON_AVAILABLE_TYPE.TARGET_PRODUCT_COUPON],
  },
  {
    id: COUPON_AVAILABLE_TYPE.TARGET_BRAND_COUPON,
    name: COUPON_AVAILABLE_TYPE_TEXT[COUPON_AVAILABLE_TYPE.TARGET_BRAND_COUPON],
  },
];

/**
 *  쿠폰 상태 타입
 */
export const COUPON_STATUS_TYPE = {
  /**
   *  비활성
   */
  INACTIVE: 0,
  /**
   *  활성
   */
  ACTIVATE: 1,
};

/**
 *  쿠폰 상태 타입 TEXT
 */
export const COUPON_STATUS_TYPE_TEXT = {
  [COUPON_STATUS_TYPE.INACTIVE]: '비활성',
  [COUPON_STATUS_TYPE.ACTIVATE]: '활성',
};

/**
 *  쿠폰 상태 타입 SELECT LIST
 */
export const COUPON_STATUS_TYPE_SELECT_LIST = [
  {
    id: COUPON_STATUS_TYPE.INACTIVE,
    name: COUPON_STATUS_TYPE_TEXT[COUPON_STATUS_TYPE.INACTIVE],
  },
  {
    id: COUPON_STATUS_TYPE.ACTIVATE,
    name: COUPON_STATUS_TYPE_TEXT[COUPON_STATUS_TYPE.ACTIVATE],
  },
];

/**
 *  쿠폰 다운로드 여부
 */
export const COUPON_DOWNLOAD_STATUS_TYPE = {
  /**
   *  비활성
   */
  INACTIVE: 0,
  /**
   *  활성
   */
  ACTIVATE: 1,
};

/**
 *  쿠폰 다운로드 여부 TEXT
 */
export const COUPON_DOWNLOAD_STATUS_TYPE_TEXT = {
  [COUPON_DOWNLOAD_STATUS_TYPE.INACTIVE]: '비활성',
  [COUPON_DOWNLOAD_STATUS_TYPE.ACTIVATE]: '활성',
};

/**
 *  쿠폰 다운로드 여부 SELECT LIST
 */
export const COUPON_DOWNLOAD_STATUS_TYPE_SELECT_LIST = [
  {
    id: COUPON_DOWNLOAD_STATUS_TYPE.INACTIVE,
    name: COUPON_DOWNLOAD_STATUS_TYPE_TEXT[COUPON_DOWNLOAD_STATUS_TYPE.INACTIVE],
  },
  {
    id: COUPON_DOWNLOAD_STATUS_TYPE.ACTIVATE,
    name: COUPON_DOWNLOAD_STATUS_TYPE_TEXT[COUPON_DOWNLOAD_STATUS_TYPE.ACTIVATE],
  },
];

/**
 *  쿠폰 할인 타입 SELECT
 */
export const COUPON_DISCOUNT_TYPE = {
  /**
   *  정액 할인
   */
  PRICE: 0,
  /**
   *  정률 할인
   */
  RATE: 1,
};

/**
 *  쿠폰 할인 타입 SELECT TEXT
 */
export const COUPON_DISCOUNT_TYPE_TEXT = {
  [COUPON_DISCOUNT_TYPE.PRICE]: '정액 할인',
  [COUPON_DISCOUNT_TYPE.RATE]: '정률 할인',
};

/**
 *  쿠폰 할인 타입 SELECT 리스트
 */
export const COUPON_DISCOUNT_TYPE_SELECT_LIST = [
  {
    id: COUPON_DISCOUNT_TYPE.PRICE,
    name: COUPON_DISCOUNT_TYPE_TEXT[COUPON_DISCOUNT_TYPE.PRICE],
  },
  {
    id: COUPON_DISCOUNT_TYPE.RATE,
    name: COUPON_DISCOUNT_TYPE_TEXT[COUPON_DISCOUNT_TYPE.RATE],
  },
];

/**
 *  쿠폰 할인 타입 SELECT
 */
export const BRAND_DISCOUNT_RATE_TYPE = {
  /**
   *  정액 할인
   */
  AMOUNT: 0,
  /**
   *  정률 할인
   */
  RATE: 1,
};

/**
 *  쿠폰 할인 타입 SELECT TEXT
 */
export const BRAND_DISCOUNT_RATE_TYPE_TEXT = {
  [BRAND_DISCOUNT_RATE_TYPE.AMOUNT]: '정액 분담',
  [BRAND_DISCOUNT_RATE_TYPE.RATE]: '정률 분담',
};

/**
 *  쿠폰 할인 타입 SELECT 리스트
 */
export const BRAND_DISCOUNT_RATE_TYPE_SELECT_LIST = [
  {
    id: BRAND_DISCOUNT_RATE_TYPE.AMOUNT,
    name: BRAND_DISCOUNT_RATE_TYPE_TEXT[BRAND_DISCOUNT_RATE_TYPE.AMOUNT],
  },
  {
    id: BRAND_DISCOUNT_RATE_TYPE.RATE,
    name: BRAND_DISCOUNT_RATE_TYPE_TEXT[BRAND_DISCOUNT_RATE_TYPE.RATE],
  },
];

/**
 *  쿠폰 사용 기간 타입
 */
export const COUPON_PERIOD_TYPE = {
  /**
   *  시작 종료 날짜 지정 기준
   */
  START_AND_END_DATE: 0,
  /**
   *  발급일 +날짜 기준
   */
  DAY_PLUS: 1,
  /**
   *  무기한
   */
  INFINITE: 2,
};

/**
 *  쿠폰 사용 기간 타입 SELECT 리스트
 */
export const COUPON_PERIOD_TYPE_SELECT_LIST = [
  {
    id: 0,
    name: '날짜 지정',
  },
  {
    id: 1,
    name: '발급일 기준',
  },
  {
    id: 2,
    name: '무기한',
  },
];

/**
 *  쿠폰 발급 제한 횟수 타입
 */
export const COUPON_GENERATE_LIMIT_TYPE = {
  /**
   *  주기당 몇번
   */
  MULTIPLE_CYCLE: 0,
  /**
   *  평생에 몇번
   */
  MULTIPLE_FOREVER: 1,
  /**
   *  무제한
   */
  UNLIMIT: 2,
};

/**
 *  쿠폰 발급 제한 횟수 타입 텍스트
 */
export const COUPON_GENERATE_LIMIT_TYPE_TEXT = {
  /**
   *  주기당 몇번
   */
  [COUPON_GENERATE_LIMIT_TYPE.MULTIPLE_CYCLE]: '주기당 몇번',
  /**
   *  평생에 몇번
   */
  [COUPON_GENERATE_LIMIT_TYPE.MULTIPLE_FOREVER]: '평생에 몇번',
  /**
   *  무제한
   */
  [COUPON_GENERATE_LIMIT_TYPE.UNLIMIT]: '무제한',
};

/**
 *  쿠폰 발급 제한 횟수 타입 SELECT 리스트
 */
export const COUPON_GENERATE_LIMIT_TYPE_SELECT_LIST = [
  {
    id: COUPON_GENERATE_LIMIT_TYPE.MULTIPLE_CYCLE,
    name: COUPON_GENERATE_LIMIT_TYPE_TEXT[COUPON_GENERATE_LIMIT_TYPE.MULTIPLE_CYCLE],
  },
  {
    id: COUPON_GENERATE_LIMIT_TYPE.MULTIPLE_FOREVER,
    name: COUPON_GENERATE_LIMIT_TYPE_TEXT[COUPON_GENERATE_LIMIT_TYPE.MULTIPLE_FOREVER],
  },
  {
    id: COUPON_GENERATE_LIMIT_TYPE.UNLIMIT,
    name: COUPON_GENERATE_LIMIT_TYPE_TEXT[COUPON_GENERATE_LIMIT_TYPE.UNLIMIT],
  },
];

/**
 *  쿠폰 사용 가능한 브랜드에서 조회하는 상품 상태 리스트
 */
export const COUPON_BRAND_LINK_PRODUCT_STATUS_LIST = [PRODUCT_STATUS.NOW_ON_SALE, PRODUCT_STATUS.SOLD_OUT];

/**
 *  쿠폰 사용 기간 타입 TEXT
 */
export const COUPON_PERIOD_TYPE_TEXT = {
  0: '날짜 지정',
  1: '발급일 기준',
  2: '무기한',
};

/**
 *  쿠폰 사용 여부 텍스트
 */
export const COUPON_IS_USED_TYPE_TEXT = {
  0: '미사용',
  1: '사용',
};

/**
 *  쿠폰 사용 여부 SELECT 리스트
 */
export const COUPON_IS_USED_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '미사용',
  },
  {
    id: 1,
    name: '사용',
  },
];

/**
 *  쿠폰명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_COUPON_NAME = 26;

/**
 *  쿠폰 설명 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_COUPON_DESCRIPTION = 30;

/**
 *  쿠폰메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_COUPON_MEMO = 250;

/**
 *  쿠폰 코드 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_COUPON_CODE = 20;

/**
 *  쿠폰 최소 구매 금액의 최소 가격
 */
export const COUPON_MINIMUM_PURCHASE_MINIMUM_PRICE = 2000;

/**
 *  쿠폰 최소 구매 금액의 최대 가격
 */
export const COUPON_MINIMUM_PURCHASE_MAXIMUM_PRICE = 1000000;

/**
 *  쿠폰 혜택 수치 금액(정액)의 최소 가격
 */
export const COUPON_DISCOUNT_PRICE_AMOUNT_MINIMUM_PRICE = 10;

/**
 *  쿠폰 혜택 수치 금액(정액)의 최대 가격
 */
export const COUPON_DISCOUNT_PRICE_AMOUNT_MAXIMUM_PRICE = 100000;

/**
 *  쿠폰 혜택 수치 금액(정률)의 최소 가격
 */
export const COUPON_DISCOUNT_RATE_AMOUNT_MINIMUM_PRICE = 1;

/**
 *  쿠폰 혜택 수치 금액(정률)의 최대 가격
 */
export const COUPON_DISCOUNT_RATE_AMOUNT_MAXIMUM_PRICE = 99;

/**
 *  쿠폰 최대 할인 가능 금액의 최소 가격
 */
export const COUPON_MAX_DISCOUNT_MINIMUM_PRICE = 1000;

/**
 *  쿠폰 최대 할인 가능 금액의 최대 가격
 */
export const COUPON_MAX_DISCOUNT_MAXIMUM_PRICE = 6_000_000;

/**
 *  시작일로부터 +며칠 인지의 최소 일수
 */
export const COUPON_DAY_PLUS_MINIMUM_DAY = 0;

/**
 *  시작일로부터 +며칠 인지의 최대 일수
 */
export const COUPON_DAY_PLUS_MAXIMUM_DAY = 365;

/**
 *  쿠폰 발급 제한 최소 날짜
 */
export const COUPON_GENERATE_LIMIT_DAY_MIN = 1;

/**
 *  쿠폰 발급 제한 최대 날짜
 */
export const COUPON_GENERATE_LIMIT_DAY_MAX = 365;

/**
 *  쿠폰 발급 제한 최소 횟수
 */
export const COUPON_GENERATE_LIMIT_COUNT_MIN = 1;

/**
 *  쿠폰 발급 제한 최대 횟수
 */
export const COUPON_GENERATE_LIMIT_COUNT_MAX = 30;

/**
 *  쿠폰 사용률 차트 색상
 */
export const COUPON_USAGE_RATE_CHART_COLORS = {
  /**
   *  쿠폰 사용
   */
  used: '#7048e8',
  /**
   *  쿠폰 미사용
   */
  unUsed: '#ff922b',
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(유저 번호)
 */
export const INVALID_BULK_GENERATE_COUPON_USER_CASE_TYPE = {
  /**
   *  유효하지 않은 회원 번호
   */
  INVALID_USER_ID: 0,
  /**
   *  중복되는 유저 번호, 쿠폰 번호
   */
  DUPLICATE_USER_ID_COUPON_ID: 1,
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(회원 상태)
 */
export const INVALID_BULK_GENERATE_COUPON_USER_STATUS_CASE_TYPE = {
  /**
   *  유효하지 않은 회원 상태
   */
  INVALID_STATUS: 0,
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(쿠폰 번호)
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_TYPE = {
  /**
   *  유효하지 않은 쿠폰 번호
   */
  INVALID_COUPON_ID: 0,
  /**
   *  중복되는 유저 번호, 쿠폰 번호
   */
  DUPLICATE_USER_ID_COUPON_ID: 1,
  /**
   *  유효하지 않은 쿠폰 상태
   */
  INVALID_COUPON_STATUS: 2,
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(전화 번호)
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_CELL_PHONE_TYPE = {
  /**
   *  유효하지 않은 전화 번호
   */
  INVALID_CELL_PHONE: 0,
  /**
   *  압력된 userId 와 cellPhone 으로 얻어온 userId 가 다를때
   */
  DIFFERENCE_USER_ID: 1,
  /**
   *  해당 cellPhone 이 여러 userId 가 붙어있는 경우
   */
  DUPLICATE_CELL_PHONE: 2,
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(쿠폰 발급 수량)
 */
export const INVALID_BULK_GENERATE_COUPON_ISSUED_CASE_TYPE = {
  /**
   *  유효하지 않은 쿠폰 발급 수
   */
  INVALID_ISSUED_COUNT: 0,
  /**
   *  최대 발급수를 넘긴 발급수
   */
  OVER_MAXIMUM_NUMBER_OF_ISSUED_COUPON_COUNT: 1,
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(유저 번호)
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_USER_TYPE_TEXT = {
  /**
   *  유효하지 않은 회원 번호
   */
  [INVALID_BULK_GENERATE_COUPON_USER_CASE_TYPE.INVALID_USER_ID]: '유효하지 않은 회원번호입니다.',
  /**
   *  중복되는 유저 번호, 쿠폰 번호
   */
  [INVALID_BULK_GENERATE_COUPON_USER_CASE_TYPE.DUPLICATE_USER_ID_COUPON_ID]:
    '일괄 변경할 유저번호, 쿠폰번호가 중복됩니다.',
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(회원 상태)
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_USER_STATUS_TYPE_TEXT = {
  /**
   *  유효하지 않은 회원 상태
   */
  [INVALID_BULK_GENERATE_COUPON_USER_STATUS_CASE_TYPE.INVALID_STATUS]: '유효하지 않은 회원상태입니다.',
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(쿠폰 번호)
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_TYPE_TEXT = {
  /**
   *  유효하지 않은 쿠폰 번호
   */
  [INVALID_BULK_GENERATE_COUPON_CASE_TYPE.INVALID_COUPON_ID]: '유효하지 않은 쿠폰번호입니다.',
  /**
   *  중복되는 유저 번호, 쿠폰 번호
   */
  [INVALID_BULK_GENERATE_COUPON_CASE_TYPE.DUPLICATE_USER_ID_COUPON_ID]: '일괄 변경할 유저번호, 쿠폰번호가 중복됩니다.',
  /**
   *  유효하지 않은 쿠폰 상태
   */
  [INVALID_BULK_GENERATE_COUPON_CASE_TYPE.INVALID_COUPON_STATUS]: '유효하지 않은 쿠폰상태입니다.',
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(전화 번호)
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_CELL_PHONE_TYPE_TEXT = {
  /**
   *  유효하지 않은 전화 번호
   */
  [INVALID_BULK_GENERATE_COUPON_CASE_CELL_PHONE_TYPE.INVALID_CELL_PHONE]: '유효하지 않은 휴대전화 번호입니다.',
  /**
   *  압력된 userId 와 cellPhone 으로 얻어온 userId 가 다를때
   */
  [INVALID_BULK_GENERATE_COUPON_CASE_CELL_PHONE_TYPE.DIFFERENCE_USER_ID]:
    '입력 하신 유저 번호와 휴대전화 번호로 받아온 유저 번호가 다릅니다',
  /**
   *  해당 cellPhone 이 여러 userId 가 붙어있는 경우
   */
  [INVALID_BULK_GENERATE_COUPON_CASE_CELL_PHONE_TYPE.DUPLICATE_CELL_PHONE]:
    '입력 하신 휴대전화 번호로 받아온 유저가 여러명입니다.',
};

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입(쿠폰 발급 수량)
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_ISSUED_TYPE_TEXT = {
  /**
   *  유효하지 않은 쿠폰 발급 수
   */
  [INVALID_BULK_GENERATE_COUPON_ISSUED_CASE_TYPE.INVALID_ISSUED_COUNT]: '유효하지 않은 쿠폰 발급 수입니다.',
  /**
   *  최대 발급수를 넘긴 발급수
   */
  [INVALID_BULK_GENERATE_COUPON_ISSUED_CASE_TYPE.OVER_MAXIMUM_NUMBER_OF_ISSUED_COUPON_COUNT]:
    '한 유저당 최대 쿠폰 발급 수는 100개 입니다.',
};

/**
 *  불가능한 상품/브랜드 엑셀 다운로드 관련 상수
 */
export const COUPON_EXCEL_CONSTANTS = {
  UNKNOWN_ERROR: '알 수 없는 오류',
  EMPTY_VALUE: '-',
  SHEET_NAME: '불가능 항목',
};

/**
 *  쿠폰 사용 가능한 상품 엑셀 업로드 시 유효하지 않은 경우 타입
 */
export const INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TYPE = {
  /**
   *  유효하지 않은 상품 번호
   */
  INVALID_PRODUCT_ID: 0,
  /**
   *  상품의 상태가 품절, 판매중이 아닐때
   */
  INVALID_PRODUCT_STATUS: 1,
  /**
   *  브랜드의 상태가 활성화 상태가 아닐때
   */
  INVALID_BRAND_STATUS: 2,
  /**
   *  상품의 실 판매가가 쿠폰 최소 결제 금액에 미달될때
   */
  INVALID_PRODUCT_PRICE: 3,
  /**
   *  상품 번호가 중복될때
   */
  DUPLICATE_PRODUCT_ID: 4,
  /**
   *  쿠폰 할인 타입이 정률 쿠폰이고 상품 할인액이 최대 할인액보다 클때
   */
  INVALID_COUPON_DISCOUNT_AMOUNT: 5,
};

/**
 *  쿠폰 사용 가능한 상품 엑셀 업로드 시 유효하지 않은 경우 테스트
 */
export const INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TEXT = {
  [INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TYPE.INVALID_PRODUCT_ID]: '유효한 상품 번호가 아닙니다.',
  [INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TYPE.INVALID_PRODUCT_STATUS]: '유효한 상품 상태가 아닙니다.',
  [INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TYPE.INVALID_BRAND_STATUS]: '상품의 브랜드 상태가 유효하지 않습니다.',
  [INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TYPE.INVALID_PRODUCT_PRICE]:
    '쿠폰 최소 결제 금액에 미달되는 상품입니다.',
  [INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TYPE.DUPLICATE_PRODUCT_ID]: '중복된 상품 번호입니다.',
  [INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TYPE.INVALID_COUPON_DISCOUNT_AMOUNT]:
    '상품 할인액이 최대 할인액보다 큽니다.(정률 할인 쿠폰)',
};

/**
 *  쿠폰 사용 가능한 브랜드 엑셀 업로드 시 유효하지 않은 경우 타입
 */
export const INVALID_COUPON_BRAND_ITEM_EXCEL_UPLOAD_CASE_TYPE = {
  /**
   *  유효하지 않은 브랜드 번호
   */
  INVALID_BRAND_ID: 0,
  /**
   *  브랜드의 상태가 활성화가 아닐때
   */
  INVALID_BRAND_STATUS: 1,
  /**
   *  브랜드 번호가 중복될떄
   */
  DUPLICATE_BRAND_ID: 2,
};

/**
 *  쿠폰 사용 가능한 브랜드 엑셀 업로드 시 유효하지 않은 경우 텍스트
 */
export const INVALID_COUPON_BRAND_ITEM_EXCEL_UPLOAD_CASE_TEXT = {
  [INVALID_COUPON_BRAND_ITEM_EXCEL_UPLOAD_CASE_TYPE.INVALID_BRAND_ID]: '유효하지 않은 브랜드 ID 입니다.',
  [INVALID_COUPON_BRAND_ITEM_EXCEL_UPLOAD_CASE_TYPE.INVALID_BRAND_STATUS]: '브랜드의 상태가 활성화 상태가 아닙니다.',
  [INVALID_COUPON_BRAND_ITEM_EXCEL_UPLOAD_CASE_TYPE.DUPLICATE_BRAND_ID]: '중복된 브랜드 ID 입니다.',
};

/**
 *  쿠폰 발급 서치박스 label 부분 TYPE
 */
export const COUPON_GENERATE_SEARCH_BOX_TYPE = {
  /**
   *  회원 번호
   */
  USER_ID: 0,
  /**
   *  전화 번호
   */
  CELLPHONE: 1,
};

/**
 *  쿠폰 발급 서치박스 label 부분 TEXT
 */
export const COUPON_GENERATE_SEARCH_BOX_TEXT = {
  /**
   *  회원 번호
   */
  [COUPON_GENERATE_SEARCH_BOX_TYPE.USER_ID]: '회원 번호',
  /**
   *  전화 번호
   */
  [COUPON_GENERATE_SEARCH_BOX_TYPE.CELLPHONE]: '휴대전화 번호',
};

/**
 *  쿠폰 발급 서치박스 label 부분 SELECT LIST
 */
export const COUPON_GENERATE_SEARCH_BOX_SELECT_LIST = [
  {
    id: COUPON_GENERATE_SEARCH_BOX_TYPE.USER_ID,
    name: COUPON_GENERATE_SEARCH_BOX_TEXT[COUPON_GENERATE_SEARCH_BOX_TYPE.USER_ID],
  },
  {
    id: COUPON_GENERATE_SEARCH_BOX_TYPE.CELLPHONE,
    name: COUPON_GENERATE_SEARCH_BOX_TEXT[COUPON_GENERATE_SEARCH_BOX_TYPE.CELLPHONE],
  },
];

/**
 *  쿠폰 발급 서치박스에서 userId 의 쵀대 길이
 */
export const MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID = 1000;

/**
 *  쿠폰 일괄 발급 시 유효한 경우 타입 텍스트
 */
export const VALID_BULK_GENERATE_COUPON_CASE_TEXT = '쿠폰 발급 가능';

/**
 *  쿠폰 일괄 발급 시 유효하지 않은 경우 타입 텍스트
 */
export const INVALID_BULK_GENERATE_COUPON_CASE_TEXT = '쿠폰 발급 불가능';

/**
 *  쿠폰 사용 가능한 상품, 브랜드 엑셀 업로드시 유효한 경우 타입 텍스트
 */
export const VALID_EXCEL_UPLOAD_COUPON_CASE_TEXT = '엑셀 업로드 가능';

/**
 *  쿠폰 사용 가능한 상품, 브랜드 엑셀 업로드시 유효하지 않은 경우 타입 텍스트
 */
export const INVALID_EXCEL_UPLOAD_COUPON_CASE_TEXT = '엑셀 업로드 불가능';

/**
 *  쿠폰 기간 PLACEHOLDER 텍스트
 */
export const PLACEHOLDER_TEXT_COUPON_PERIOD_DATE = 'YYYY년 M월 D일 H시 m분 s초';

/**
 *  쿠폰 리스트가 없을 때 보여주는 텍스트
 */
export const COUPON_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 쿠폰 리스트가 없습니다.';

/**
 *  선택된 쿠폰 리스트가 없을 때 보여주는 텍스트
 */
export const SELECTED_COUPON_LIST_TABLE_EMPTY_TEXT = '선택된 쿠폰 리스트가 없습니다.';

/**
 *   선택된 유저 리스트가 없을 때 보여주는 텍스트
 */
export const COUPON_SELECTED_USER_LIST_TABLE_EMPTY_TEXT = '선택된 유저 리스트가 없습니다.';

/**
 *  유저 리스트가 없을 때 보여주는 텍스트
 */
export const COUPON_USER_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 유저 리스트가 없습니다.';

/**
 *  쿠폰 메모 최대 글자
 */
export const MAXIMUM_NUMBER_OF_COUPON_MEMO_TEXT = 1000;

/**
 *  쿠폰 발급 최대명수 (20 명이 최대)
 */
export const MAXIMUM_NUMBER_OF_COUPON_GENERATE_USER = 20;

/**
 *  쿠폰 발급 최대 쿠폰 종류 (20 종류가 최대)
 */
export const MAXIMUM_NUMBER_OF_COUPON_KIND = 20;

/**
 *  쿠폰 발급 수량 최대 갯수
 */
export const MAXIMUM_NUMBER_OF_COUPON_ISSUED_COUNT = 100;

/**
 *  쿠폰 발급 수량 최소 갯수
 */
export const MINIMUM_NUMBER_OF_COUPON_ISSUED_COUNT = 1;

/**
 *  쿠폰 액션 이름
 */
export const COUPON_ACTIONS_NAME = 'couponActions';

/**
 *  쿠폰 정보 탭 index
 */
export const COUPON_INFO_TAB_INDEX = 0;

/**
 *  쿠폰 사용 가능한 상품 탭 index
 */
export const COUPON_PRODUCT_LINK_INFO_TAB_INDEX = 1;

/**
 *  쿠폰 사용 가능한 브랜드 탭 index
 */
export const COUPON_BRAND_LINK_INFO_TAB_INDEX = 2;

export const DOWNLOADABLE_COUPON_NOTIFICATION =
  '‘활성’ 쿠폰은 상품 상세 페이지에서 ‘쿠폰 다운로드’ 기능이 적용됩니다.  \n관리자 발급(CS 등), 조건부 발급(등급, 이벤트 참여용 등) 쿠폰은 ‘비활성’으로 생성하세요.';
